export default __webpack_public_path__ + "static/media/login-main-image.1411822c.png";